import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteInventorysFromAPI, fetchInventorysFromAPI } from "../../../services/InventoryService";

// Get today's date in YYYY-MM-DD format
const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const fetchInventorys = createAsyncThunk(
  "inventorys/fetchInventorys",
  async ({ page, perPage, search }, { rejectWithValue }) => {
    try {
      const response = await fetchInventorysFromAPI(page, perPage, search);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteInventory = createAsyncThunk(
  "inventorys/deleteInventory",
  async (inventoryId, { rejectWithValue }) => {
    try {
      const response = await deleteInventorysFromAPI(inventoryId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);



const inventorySlice = createSlice({
  name: "inventorys",
  initialState: {
    inventorys: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    inventorySearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:{
      period_from: getTodayDate(),
      period_to: getTodayDate(),
      vendor_code: '',
      search: ''
    }
  },
  reducers: {
    setSearchInventory: (state, action) => {
      state.inventorySearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventorys.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInventorys.fulfilled, (state, action) => {
        const inventorys = action.payload.inventories;
        state.loading = false;
        state.inventorys = inventorys.data;
        state.currentPage = inventorys.current_page;
        state.lastPage = inventorys.last_page;
        state.perPage = inventorys.per_page;
        state.firstItem = inventorys.from; // ✅ Ambil `from` dari API
        state.totalCount = inventorys.total;
      })
      .addCase(fetchInventorys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteInventory.fulfilled, (state, action) => {
        state.inventorys = state.inventorys.filter(inventory => inventory.id !== action.payload);
      })
      .addCase(deleteInventory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchInventory, setPage, setVisibilityFilter, setPerPage, setKeywordSearch } = inventorySlice.actions;
export default inventorySlice.reducer;
